import React from 'react';
import { createRoot } from 'react-dom/client';
import App from "./App";
import { AuthProvider } from './hooks/useAuth';
import { SideBarProvider } from './hooks/useSidebar';
import { Toaster } from 'react-hot-toast'


const rootNode = document.getElementById("app");
if (rootNode) {
  createRoot(rootNode)
    .render(
      <React.StrictMode>
        <Toaster
          position="top-right"
          reverseOrder={false}
        />
        <AuthProvider>
          <SideBarProvider>
            <App />
          </SideBarProvider>
        </AuthProvider>
      </React.StrictMode>,
    );
}